import { EventRepository } from '../repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '../domain/entities/Event';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export class AppointmentVirtualSelectedUseCase {
    private eventRepository: EventRepository;

    constructor() {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
    }

    public execute = async () => {
        const appointmentVirtualSelectedPayload = {
            event_name: 'appointment booking',
            event_category: 'appointment booking',
            event_action: 'location selected',
            event_label: 'virtual consultation'
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.APPOINTMENT_VIRTUAL_SELECTED,
            type: 'link',
            payload: appointmentVirtualSelectedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
